<template>
<div class="containers">
    <div v-if="goArea == true" class="area-list">
        <div class="search-area">
            <CRow>
                <CCol sm="7">
                    <input type="text" v-model="searchValue" :placeholder="placeHolder" class="form-control"/>
                </CCol>
                <CCol sm="3">
                    <model-select style="background-color:rgba(249, 250, 252, 1)" :options="dataFilter" class="form-control" v-model="selectedFilter" placeholder="Pilih Tim"></model-select>
                </CCol>
                <CCol sm="2">
                    <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
                </CCol>
            </CRow>
        </div>
        <div class="sticky1">
            <CRow>
                <CCol sm="6"></CCol>
                <CCol sm="6">
                    <span style="float:right">
                        <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                        <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    </span>
                    <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                    <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                    <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
                    <img class="mt-1 mr-5" :src="moreIcon" width="20px" height="20px" style="float:right"/>
                    <img class="mr-5 mt-1" @click="reload()" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="float:right;cursor:pointer"/>
                </CCol>
            </CRow>
        </div>
        <Tables @sort="sorting" :data="datas" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
    </div>
</div>
</template>

<script>
import Tables from '../../../component/tableDetailHasilTes'
import {DataApi} from "../../../service/DataApi";
import { ModelSelect } from 'vue-search-select'
export default {
    components: {
        Tables,
        ModelSelect
    },
    data() {
        return {
            success: true,
            itemHeight: 39,

            refreshIcon: require('../../../assets/menu/icon_refresh.svg'),
            backIcon: require('../../../assets/menu/icon_goback.svg'),
            moreIcon: require('../../../assets/menu/icon_more.svg'),
            closeIcon: require('../../../assets/menu/icon_close.svg'),
            downloadIcon: require('../../../assets/menu/icon_download_excel.svg'),
            dataTh: ['Nama Atasan', 'Nama Tim', 'Total Pegawai', 'Total Reaktif', 'Kontak Erat'],
            dataTd: [['nama', 'jabatan'], 'keterangan', 'totalPegawai', 'jumlahReaktif', 'jumlahKontakErat'],
            styleTable: ['200px', '200px', '125px', '125px', '125px'],
            classReload: 'reloadOff',
            goArea: true,
            loading: false,
            alertMess: '',
            currentAlertCounter: 0,


            // pagination
            page: 1,
            size: 20,
            totalRow: 0,
            totalPage: 1,
            firstPage: 0,
            lastPage: 0,

            searchValue: '',
            
            // datas
            datas: [],
            dataFilter: [],
            selectedFilter: {
                value: '1',
                text: 'Divisi'
            },

            placeHolder: 'Cari Divisi / SBU / Nama Vice President / Nama General Manager',


            //error
            errorMessage: '',
            modalDetail: false,
            flagSearch: false
        }
    },
    computed: {
    },
    watch: {
        page() {
            window.scroll({
                top:300,
                left: 0,
                behavior: 'smooth'
            });
        },
        searchValue() {
            this.flagSearch = true
        },
        selectedFilter() {
            this.flagSearch = true
        },
        goArea() {
            window.scroll({
                top:300,
                left: 0,
                behavior: 'smooth'
            });
        },
        selectedFilter() {
            if(this.selectedFilter.value == '1') {
                this.placeHolder = 'Cari Divisi / SBU / Nama Vice President / Nama General Manager'
            } else if(this.selectedFilter.value == '2') {
                this.placeHolder = 'Cari Bidang / Nama Manager'
            } else if(this.selectedFilter.value == '3') {
                this.placeHolder = 'Cari Sub Bidang / Nama Supervisor'
            }
            this.searchValue = ''
        }
    },
    methods: {
        /**
         * GET DATA
         */
        sorting(value) {
            if(value == 0) {
                function compare(a,b) {
                    if (a.kantor.toLowerCase() < b.kantor.toLowerCase()) {
                        return -1
                    }
                    if (a.kantor.toLowerCase() > b.kantor.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 1) {
                function compare(a,b) {
                    if (a.tanggal.toLowerCase() < b.tanggal.toLowerCase()) {
                        return -1
                    }
                    if (a.tanggal.toLowerCase() > b.tanggal.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            }
        },
        getData() {
            if(this.flagSearch == true) {
                this.page = 1
            }
            this.$store.state.loadingScreen = true
            let limit = this.size
            let filter = this.searchValue
            let page = this.page
            let tipe = this.selectedFilter.value

            let payload = {
                limit: limit,
                filter: filter,
                pageIn: page,
                tipe: tipe
            }
            DataApi.post("rta/rekap/lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datas = response.data.data
                    this.totalRow = response.data.totalRow
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                } else {
                    this.datas = []
                    this.totalRow = 0
                    this.firstPage = 0
                    this.lastPage = 0
                    this.totalPage = 1
                    this.errorMessage = response.message
                }
                this.flagSearch = false
                this.$store.state.loadingScreen = false
            })
        },
        findData() {
            this.getData()
        },
        movePage(direction) {
            if(direction == 'prev') {
                this.page = this.page -  1
            } else {
                this.page = this.page +  1
            }
            this.getData()
        },
        validatePage(page) {
            if(page > this.totalPage) {
                this.page = this.totalPage
            }
        },
        reload() {
            this.searchValue = ''
            this.flagSearch = true
            this.getData()
            if (this.classReload == 'reloadOff') {
                this.classReload = 'reloadOn'
            } else {
                this.classReload = 'reloadOff'
            }
        },
        getDataFilter() {
            this.dataFilter = [
                { value: '1', text: 'Divisi' },
                { value: '2', text: 'Bidang' },
                { value: '3', text: 'Sub Bidang' }
            ]
        },
        getDownload() {
            this.$store.state.loadingScreen = true
            let limit = this.totalRowDetail
            let page = 1

            let payload = {
                idKantor: this.idKantor,
                idPegawai: this.idPegawai,
                limit: limit,
                pageIn: page,
                status: '',
                tanggal: this.tanggalKantor,
                unixJadwal: this.filterJam.value
            }
            DataApi.post("rta/absen/lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    let downloads = response.data.data
                    let fileName = 'Daftar Peserta Tes ' + this.dataNamaKantor + ' Tanggal ' + this.tanggalKantor
                    let data = [
                        {
                            sheet: 'Peserta',
                            columns: [
                                { label: 'Nama Peserta', value: 'nama'  },
                                { label: 'NIP', value: 'nik' },
                                { label: 'Nomor KTP', value: 'noKtp' },
                                { label: 'Tanggal Lahir', value: 'tanggalLahir' },
                                { label: 'Nama Atasan', value: 'namaAtasan' },
                                { label: 'Jam Pelaksanaan', value: 'jam' },
                                { label: 'Status', value: 'status' },
                            ],
                            content: downloads
                        }
                    ]
                    let settings = {
                        fileName: fileName
                    }
                    xlsx(data, settings)
                }
                this.$store.state.loadingScreen = false
            })
        },
    },
    mounted() {
        this.errorMessage = 'Find Your Data'
        this.getDataFilter()
    },
}
</script>
<style scoped>
.containers {
    background-color: white;
    border-bottom: 1px solid #e5e6e8;
}
.btn-search {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 255, 1);
    color: white;
}
.btn-add {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-add:hover {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.btn-cancel {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-cancel:hover {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.reloadOn {
    float: left;
    cursor: pointer;
    transform: rotate(-180deg);
    transition: 300ms linear all;
}
.reloadOff {
    float: left;
    cursor: pointer;
    transform: rotate(180deg);
    transition: 300ms linear all;
}
div.search-area {
    padding-top: 12px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 6px !important;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 54px;
    padding-top: 6px;
    padding-right: 20px;
    padding-left: 20px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
div.sticky2 {
    position: -webkit-sticky;
    position: sticky;
    top: 105px;
    background-color: white;
    z-index: 1;
}
input {
    background-color: rgba(249, 250, 252, 1);
}
.area-edit {
    background-color: white;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
}
.area-back {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input label {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
    font-weight: 600;
    margin-bottom: 12px;
}
.area-input input, .area-input .model-select, .area-input .autocomplete {
    background-color: white;
    margin-bottom: 20px;
}
.area-button-submit {
    padding-left: 20px;
    padding-bottom: 20px;
    padding-top: 32px;
}
.select-invalid {
    border: 1px solid #e55353 !important;
}
.select-valid {
    border: 1px solid #2eb85c !important;
}
.btn-edit-submit {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:rgba(48, 107, 221, 1);
    color: white;
    font-size: 14px;
}
.cards-image {
    position: absolute;
    text-align: center;
    font-size: 27px;
    color: rgba(96, 96, 96, 1);
    line-height: 50px;
    border: 1px dotted rgba(221, 221, 221, 1);
    width: 56px !important;
    background-color: rgba(250, 250, 250, 1);
    height: 56px !important;
}
.autocomplete {
    width: 100%;
    position: relative;
}
.input {
    cursor: text;
}
.close {
    position: absolute;
    right: 32px;
    top: 10px;
    background: none;
    border: none;
    font-size: 14px;
    color: lightgrey;
    cursor: pointer;
}
.placeholder {
    position: absolute;
    top: 7px;
    left: 16px;
    font-size: 14px;
    color: #d0d0d0;
}
.popovers {
    text-align: center;
    width: 100% !important;
    min-height: 50px;
    border: 1px solid #d8dbe0;
    position: absolute;
    top: 40px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 3px;
    text-align: center;
    z-index: 3;
}
.popovers input {
    right: 8px;
    left: 8px;
    width: 100%;
}
.options {
    max-height: 200px;
    overflow-y: scroll;
    margin-top: 5px;
}
.options ul {
    list-style-type: none;
    text-align: left;
    padding-left: 0;
}
.ellps {
    overflow-x: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.options ul li {
    border-bottom: 1px solid lightgrey;
    padding: 10px;
    cursor: pointer;
    background: white;
}
.options ul li:first-child {
    border-top: 1px solid lightgray;
}
.options ul li:not(.selected):hover {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.options ul li.selected {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
table {
    width: 100%;
}
table thead tr {
    background-color: rgba(244, 244, 244, 1);
}
thead th {
    padding-top: 16px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 16px;
}
tbody td {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 20px;
    padding-right: 20px;
}
td,th {
    overflow-x: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap;
    border: 1px solid rgba(238, 238, 238, 1);
    font-size: 14px;
}
tr:nth-child(even) {
    background-color: rgba(252, 252, 252, 1);
}
.btn-edit {
    border-radius: 4px;
    border: 1px solid rgba(154, 154, 154, 1);
    background-color: white;
    color: black;
    font-size: 14px;
    font-weight: 600;
    width: 80px;
    height: 32px;
}
.btn-edit:hover {
    border-radius: 4px;
    border: 1px solid rgba(154, 154, 154, 1);
    background-color: rgba(154, 154, 154, 1);
    color: white;
    font-size: 14px;
    font-weight: 600;
    width: 80px;
    height: 32px;
}
::v-deep .modal-header {
    border-bottom: none !important;
}
.headers-modal {
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 18px;
    font-weight: bold;
    color: rgba(16, 16, 16, 1);
}
</style>